export enum LifecycleStageDMRB {
  GENERAL_INFORMATION = 'General Information',
  APPRAISAL = 'Appraisal',
  DESIGN = 'Design',
  MAINTENANCE_OPERATION = 'Maintenance & Operation',
  INSPECTION_ASSESSMENT = 'Inspection & Assessment',
  DISPOSAL = 'Disposal',
}
